import { parseAsDateUTC } from 'app/infrastructure/data/date';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { User } from 'app/components/access-panel/shared/types';

export const compareAccess = (newAccess: any, data: Partial<User>) =>

  !!newAccess &&

  /**
   * Checks if there are some values in original data that have been removed from serialized data
   */
  (Object.keys(data || {}).some(propertyKey => {

    const value = data[propertyKey];

    return newAccess[propertyKey] === undefined &&
      ((Array.isArray(value) && value.length > 0) ||
        (typeof value === 'object' && Object.keys(value).length > 0 &&
          value.value !== 0 && value.value !== undefined));
  }) ||

    /**
     * Checks if there are some values in serialized data that have been changed
     */
    Object.keys(newAccess).some(propertyKey => {

      /**
       * Checks simple data and { v: _ } values
       */
      if (!Array.isArray(newAccess[propertyKey])) {

        const value = newAccess[propertyKey] || undefined;
        const dataValue = data && data[propertyKey] || undefined;

        // Test dates
        if (value instanceof Date) {
          return dataValue && !!parseAsDateUTC(dataValue)
            ? !value || value.getTime() !== parseAsDateUTC(dataValue).getTime()
            : value !== dataValue;
        }

        // test objects
        if (typeof value === 'object') {
          return value.v !== (dataValue || {}).value;
        }

        // special case for handling missing data, when it was not selected code
        // (value: 0 and value: undefined)
        if (value === undefined) {
          return dataValue !== undefined && (typeof dataValue !== 'object'
            || (dataValue.value !== 0 && dataValue.value !== undefined));
        }

        // raw value check
        return value !== dataValue;

      } else {

        /**
         * Checks arrays
         */
        const dataValue = data && data[propertyKey] || [];

        // compares array lengths
        return newAccess[propertyKey].length !== dataValue.length ||

          // compares individual items if both arrays has the same length 
          newAccess[propertyKey].some(item =>

            item && item.v !== undefined

              // if item is { v: _ } seeks for same value in original data
              ? !dataValue.some(dataItem => item.v === dataItem.v)

              // if item is object, compare inner objects
              : !dataValue.some(dataItem =>

                !item || Object.keys(item).length === Object.keys(dataItem).length &&
                (Object.keys(item).length === 0 ||
                  !Object.keys(item).some(valueKey =>

                    !isDefinedIncludingZero(dataItem[valueKey]) ||
                    (item[valueKey].v === undefined
                      ? item[valueKey] !== dataItem[valueKey]
                      : item[valueKey].v !== dataItem[valueKey].v)
                  ))
              )
          );
      }
    })
  );
